module.exports = __webpack_public_path__ + "img/P150T_weapon_94.b263db10.png";